import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07a17dda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center empContractSheetTitle" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold" }, "임금메이커", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"width":"30px"} }, null, -1))
const _hoisted_4 = { style: {"display":"inline"} }
const _hoisted_5 = { class: "contractMainYearWrapper" }
const _hoisted_6 = { class: "contractMainYear" }
const _hoisted_7 = { class: "contractMainYear" }
const _hoisted_8 = { class: "contractMainYear" }
const _hoisted_9 = {
  key: 0,
  class: "contractMainYear"
}
const _hoisted_10 = { class: "contractMainYear" }
const _hoisted_11 = {
  key: 1,
  class: "contractMainYear"
}
const _hoisted_12 = {
  class: "contractMainYearWrapper",
  style: {"margin":"12px 0"}
}
const _hoisted_13 = { class: "contractMainYear" }
const _hoisted_14 = { class: "contractMainYear" }
const _hoisted_15 = { class: "contractMainYear" }
const _hoisted_16 = { class: "contractMainYear" }
const _hoisted_17 = { class: "contractMainYear" }
const _hoisted_18 = { class: "workCalcTable_empContract text-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "구분", -1))
const _hoisted_20 = {
  key: 0,
  colspan: "6"
}
const _hoisted_21 = {
  key: 1,
  colspan: "5"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "근로시간", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "9" }, "급여", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "월간", -1))
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { key: 3 }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = { key: 5 }
const _hoisted_31 = { key: 6 }
const _hoisted_32 = { key: 7 }
const _hoisted_33 = { key: 8 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "기본급", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "연장수당", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "야간수당", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "보존수당", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "당직수당", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "중식대", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "차랑비", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "양육비", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "급여총액", -1))
const _hoisted_43 = { class: "text-right" }
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = { class: "text-right" }
const _hoisted_46 = { class: "text-right" }
const _hoisted_47 = { class: "text-right" }
const _hoisted_48 = { class: "text-right" }
const _hoisted_49 = { class: "text-right" }
const _hoisted_50 = { class: "text-right" }
const _hoisted_51 = { class: "text-right" }
const _hoisted_52 = { class: "empContractSumResultsTr" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { key: 3 }
const _hoisted_57 = { key: 4 }
const _hoisted_58 = { key: 5 }
const _hoisted_59 = { key: 6 }
const _hoisted_60 = { key: 7 }
const _hoisted_61 = { key: 8 }
const _hoisted_62 = { class: "text-right" }
const _hoisted_63 = { class: "text-right" }
const _hoisted_64 = { class: "text-right" }
const _hoisted_65 = { class: "text-right" }
const _hoisted_66 = { class: "text-right" }
const _hoisted_67 = { class: "text-right" }
const _hoisted_68 = { class: "text-right" }
const _hoisted_69 = { class: "text-right" }
const _hoisted_70 = { class: "text-right" }
const _hoisted_71 = { class: "empContractAvgResultsTr" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = { key: 3 }
const _hoisted_76 = { key: 4 }
const _hoisted_77 = { key: 5 }
const _hoisted_78 = { key: 6 }
const _hoisted_79 = { key: 7 }
const _hoisted_80 = { key: 8 }
const _hoisted_81 = { class: "text-right" }
const _hoisted_82 = { class: "text-right" }
const _hoisted_83 = { class: "text-right" }
const _hoisted_84 = { class: "text-right" }
const _hoisted_85 = { class: "text-right" }
const _hoisted_86 = { class: "text-right" }
const _hoisted_87 = { class: "text-right" }
const _hoisted_88 = { class: "text-right" }
const _hoisted_89 = { class: "text-right" }
const _hoisted_90 = { class: "d-flex align-center empContractSheetTitle" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold" }, "임금계약표", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"width":"30px"} }, null, -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "기준:", -1))
const _hoisted_94 = { class: "empContractSheetDate" }
const _hoisted_95 = { class: "empListCtrlBtn_empContract mt-2 mb-4" }
const _hoisted_96 = { class: "text-center empListTable_empContract" }
const _hoisted_97 = {
  class: "empCtCheckTd",
  rowspan: "2"
}
const _hoisted_98 = ["disabled"]
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "번호", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "사원", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "계약시점", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "근로시간", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "10" }, "급여", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "임금타입", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "이름"),
  /*#__PURE__*/_createElementVNode("th", null, "직종"),
  /*#__PURE__*/_createElementVNode("th", null, "연도"),
  /*#__PURE__*/_createElementVNode("th", null, "월"),
  /*#__PURE__*/_createElementVNode("th", null, "기본"),
  /*#__PURE__*/_createElementVNode("th", null, "연장"),
  /*#__PURE__*/_createElementVNode("th", null, "야간"),
  /*#__PURE__*/_createElementVNode("th", null, "시급"),
  /*#__PURE__*/_createElementVNode("th", null, "기본급"),
  /*#__PURE__*/_createElementVNode("th", null, "연장수당"),
  /*#__PURE__*/_createElementVNode("th", null, "야간수당"),
  /*#__PURE__*/_createElementVNode("th", null, "보존수당"),
  /*#__PURE__*/_createElementVNode("th", null, "당직수당"),
  /*#__PURE__*/_createElementVNode("th", null, "중식대"),
  /*#__PURE__*/_createElementVNode("th", null, "차랑비"),
  /*#__PURE__*/_createElementVNode("th", null, "양육비"),
  /*#__PURE__*/_createElementVNode("th", null, "급여총액")
], -1))
const _hoisted_106 = { class: "empCtCheckTd" }
const _hoisted_107 = ["onUpdate:modelValue", "disabled"]
const _hoisted_108 = { class: "empCtNumTd pd26" }
const _hoisted_109 = { class: "empCtTd pd26" }
const _hoisted_110 = { class: "empCtTd pd26" }
const _hoisted_111 = { class: "empCtTd pd26" }
const _hoisted_112 = { class: "empCtTd pd26" }
const _hoisted_113 = { class: "empCtDayInputTd" }
const _hoisted_114 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown", "disabled"]
const _hoisted_115 = { class: "empCtDayInputTd" }
const _hoisted_116 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_117 = { class: "empCtDayInputTd" }
const _hoisted_118 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_119 = { class: "empCtTimePayInputTd" }
const _hoisted_120 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_121 = { class: "empCtMoneyInputTd" }
const _hoisted_122 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_123 = { class: "empCtMoneyInputTd" }
const _hoisted_124 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_125 = { class: "empCtMoneyInputTd" }
const _hoisted_126 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_127 = { class: "empCtMoneyInputTd" }
const _hoisted_128 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_129 = { class: "empCtMoneyInputTd" }
const _hoisted_130 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_131 = { class: "empCtMoneyInputTd" }
const _hoisted_132 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_133 = { class: "empCtMoneyInputTd" }
const _hoisted_134 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_135 = { class: "empCtMoneyInputTd" }
const _hoisted_136 = ["onUpdate:modelValue", "onFocus", "onBlur", "onKeydown"]
const _hoisted_137 = { class: "empCtMoneyTd pd26" }
const _hoisted_138 = { class: "empCtTd pd26" }
const _hoisted_139 = ["onClick"]
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"80px"} }, null, -1))
const _hoisted_141 = { class: "text-subtitle-1 font-weight-bold d-flex align-center mb-3" }
const _hoisted_142 = { class: "text-subtitle-1 font-weight-bold d-flex align-center mb-3" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "일괄 변경", -1))

import axios from "axios";
import { ref, watch, onMounted, computed } from "vue";
import store from "@/store";

interface Employee {
  checked?: boolean;
  emp_name: string;
  emp_job: string;
  ct_start_year?: string;
  ct_start_month?: string;
  ct_basic_work_time_month?: string | number;
  ct_over_work_time_month?: string | number;
  ct_night_work_time_month?: string | number;
  ct_time_pay?: string | number;
  ct_basic_pay?: string | number;
  ct_over_pay?: string | number;
  ct_night_pay?: string | number;
  ct_bojon_pay?: string | number;
  ct_lunch_pay?: string | number;
  ct_car_pay?: string | number;
  ct_child_pay?: string | number;
  ct_dang_pay?: string | number;
  ct_total_pay?: string | number;
  ct_wage_type?: string;
  // eslint-disable-next-line
  [key: string]: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EmpContract',
  setup(__props) {

/* eslint-disable */
const sisulCode = computed(() => store.state.AdminSisulCode);

const endYear = ref(0);
const endMonth = ref(0);
const year = ref(0);
const month = ref(1);
const timePay = ref(0);
const basicWorkTime = ref(8);
const overWorkTime = ref(1);
const overWorkDaysPercent = ref(50);
const nightWorkTime = ref(4.5) || 0;
const nightWorkDaysPercent = ref(50);

const wageVersion = ref(1);

//교대인 경우, 주간:야간 비율로 연장근로

const selectAll = ref(false);
const dialog = ref(false);
const batchEditDialog = ref(false);
const batchFields = ref<string[]>([]);
const batchEditType = ref('absolute');
const batchEditValue = ref<number | null>(null);
const isLoading = ref(false); // 로딩 상태 추가

const selectedType = ref<string[]>(['기본', '주주야야비비', '']); // 체크박스용 배열
const selectedStatus = ref<string[]>(['0', '1']); // emp_status 필터링용 배열 추가
const filteredList = ref<any[]>([]);
const inputRefs = ref([]) as any;


// eslint-disable-next-line
const yearOptions = ref([]) as any;
// eslint-disable-next-line
const monthOptions = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]) as any;
// eslint-disable-next-line
const wageLists = ref([]) as any;
// eslint-disable-next-line
const bojonPay = ref(0) as any;
// eslint-disable-next-line
const dangPay = ref(0) as any;
// eslint-disable-next-line
const lunchPay = ref(0) as any;
// eslint-disable-next-line
const carPay = ref(0) as any;
// eslint-disable-next-line
const childPay = ref(0) as any;
// eslint-disable-next-line

const refYearMonth = ref(null) as any;
// eslint-disable-next-line
const empList = ref<Employee[]>([]) as any;
// eslint-disable-next-line
const holidays = ref([]) as any;
// eslint-disable-next-line
const sumResults = ref([]) as any;
// eslint-disable-next-line
const avgResults = ref([]) as any;


const filterList = async () => {
  isLoading.value = true;
  try {
    await getEmpContractInfo();
    if (selectedType.value.length === 0 && selectedStatus.value.length === 0) {
      filteredList.value = empList.value;
    } else {
      filteredList.value = empList.value.filter((emp: any) => {
        const type = emp.ct_wage_type ?? ''; // null → ''
        const status = emp.emp_status?.toString() ?? '0'; // emp_status를 문자열로 변환
        
        const typeMatch = selectedType.value.length === 0 || selectedType.value.includes(type);
        const statusMatch = selectedStatus.value.length === 0 || selectedStatus.value.includes(status);
        
        return typeMatch && statusMatch;
      });
    }
  } finally {
    isLoading.value = false;
  }
};

// input 참조 저장
const setInputRef = (row: any, col: any, el: any) => {
  if (!inputRefs.value[row]) inputRefs.value[row] = []
  inputRefs.value[row][col] = el
}

// ↓ 방향키
const focusNextRow = (row: any, col: any) => {
  const nextRow = inputRefs.value[row + 1]
  if (nextRow && nextRow[col]) {
    nextRow[col].focus()
  }
}

// ↑ 방향키
const focusPrevRow = (row: any, col: any) => {
  const prevRow = inputRefs.value[row - 1]
  if (prevRow && prevRow[col]) {
    prevRow[col].focus()
  }
}
// ← 방향키
const focusLeftCol = (row: any, col: any) => {
  const prevCol = inputRefs.value[row]?.[col - 1]
  if (prevCol) {
    prevCol.focus()
  }
}

// → 방향키
const focusRightCol = (row: any, col: any) => {
  const nextCol = inputRefs.value[row]?.[col + 1]
  if (nextCol) {
    nextCol.focus()
  }
}
function setWageDateVersion(version: number) {
  wageVersion.value = version;
  openMonthDataStatus.value = false;
}
const openMonthDataStatus = ref(false);
const openMonthDataToggle = () => {
  openMonthDataStatus.value = !openMonthDataStatus.value;
};


const toggleAll = () => {
  const isAllChecked = empList.value.every((row: { checked: any }) => row.checked);
  selectAll.value = !isAllChecked;
  empList.value.forEach((row: { checked: any }) => {
    row.checked = selectAll.value;
  });
};

// 개별 체크박스가 변경될 때 전체 선택 상태 업데이트
watch(
  empList,
  (newVal) => {
    selectAll.value = newVal.every((row: { checked: any }) => row.checked);
  },
  { deep: true }
);

function clearFormat(item: any, key: any) {
  // 인풋의 값을 컴마 없이 만듭니다.
  item[key] = nc(item[key]);

  // 값이 0이면 빈 값으로 설정하여 placeholder를 보이도록 합니다.
  if (!item[key] || item[key] === "0" || item[key] === 0 || item[key] === "-0") {
    item[key] = "";
  }
}

function applyFormat(item: any, key: any) {
  // 값이 비어있으면 0으로 설정
  if (
    item[key] === "" ||
    item[key] === null ||
    item[key] === undefined ||
    item[key] === "-0"
  ) {
    item[key] = '';
  } else {
    // 포커스가 해제되면 천 단위로 컴마를 추가
    item[key] = formatNumber(item[key]);
  }
}

function formatNumber(value: any): string {
  // 숫자인지 확인하고 천 단위로 컴마 추가
  const number = parseFloat(value);
  if (!isNaN(number)) {
    return number.toLocaleString();
  }
  return value;
}

function ac(number: any) {
  const num = Number(number);
  if (isNaN(num)) return number;
  if (num === 0) return '';
  return num.toLocaleString();
}
function nc(value: any) {
  if (value == null) {
    return 0;
  }
  return parseFloat(value.toString().replace(/,/g, ""));
}
const totalPay = (row: any) => {
  let calc = 0
  calc =
    nc(row.ct_basic_pay || 0) + nc(row.ct_over_pay || 0) + nc(row.ct_night_pay || 0) + nc(row.ct_bojon_pay || 0) +
    nc(row.ct_lunch_pay || 0) + nc(row.ct_car_pay || 0) + nc(row.ct_child_pay || 0) + nc(row.ct_dang_pay || 0);
  row.ct_total_pay = ac(calc);
  return row.ct_total_pay;
};

const wageInput = async () => {
  // 가져오기
  const checkedRows = empList.value.filter((row: { checked: any }) => row.checked);

  if (checkedRows.length === 0) {
    alert("사원을 체크해주세요.");
    return;
  }

  const isConfirmed = window.confirm(
    "임금메이커에서 임금데이터를 [ 가져오기 ] 하시겠습니까?"
  );

  if (isConfirmed) {
    let wageType = '';
    if (wageVersion.value === 1) {
      wageType = '기본'
    } else if (wageVersion.value === 2) {
      wageType = '주주야야비비'
    }
    
    // 체크된 직원들만 데이터 업데이트
    empList.value = empList.value.map((row: { checked: any }) => {
      if (row.checked) {
        return {
          ...row,
          ct_start_year: year.value,
          ct_start_month: month.value,
          ct_end_year: endYear.value,
          ct_end_month: endMonth.value,
          ct_time_pay: ac(timePay.value),
          ct_basic_work_time: basicWorkTime.value,
          ct_over_work_time: overWorkTime.value,
          ct_night_work_time: nightWorkTime.value,
          ct_over_work_days_percent: overWorkDaysPercent.value,
          ct_night_work_days_percent: nightWorkDaysPercent.value,
          
          ct_basic_work_time_month: avgResults.value.basicTimeMonth,
          ct_over_work_time_month: avgResults.value.overTimeMonth,
          ct_night_work_time_month: avgResults.value.nightTimeMonth,
          
          ct_basic_pay: avgResults.value.basicPay,
          ct_over_pay: avgResults.value.overPay,
          ct_night_pay: avgResults.value.nightPay,
          
          ct_bojon_pay: ac(bojonPay.value),
          ct_dang_pay: ac(dangPay.value),
          ct_lunch_pay: ac(lunchPay.value),
          ct_car_pay: ac(carPay.value),
          ct_child_pay: ac(childPay.value),
          ct_total_pay: avgResults.value.totalPay,
          
          mng_id: store.getters.id,
          sisul_code: store.state.AdminSisulCode,
          ct_wage_type: wageType,
        };
      }
      return row;
    });
    
    try {
      // 체크된 직원들만 API로 저장
      const selectedEmployees = empList.value
        .filter((row: { checked: any }) => row.checked)
        .map((emp: any) => ({
          ...emp,
          ct_lunch_pay: nc(emp.ct_lunch_pay),
          ct_bojon_pay: nc(emp.ct_bojon_pay),
          ct_car_pay: nc(emp.ct_car_pay),
          ct_child_pay: nc(emp.ct_child_pay),
          ct_time_pay: nc(emp.ct_time_pay),
          ct_dang_pay: nc(emp.ct_dang_pay)
        }));
      
      const response = await axios.post("/api/saveEmpWageContract", {
        form: selectedEmployees,
      });
      
      const result = response.data;
      if (!result.success) {
        alert("실패하였습니다. 관리자에게 문의해주세요.");
      }
    } catch (error) {
      alert("처리할 수 없습니다.");
      console.error(error);
    }
    
    // 필터링된 목록 업데이트
    await filterList();
  }
};

const wageOutput = async () => {
  // 임금내보내기
  const checkedRows = empList.value.filter((row: { checked: any }) => row.checked);

  // 체크된 항목이 1개 초과인 경우 경고 메시지 출력
  if (checkedRows.length > 1) {
    alert("하나만 체크해주세요.");
    return; // 1개 초과일 경우 함수 종료
  }
  if (checkedRows.length === 1) {
    const isConfirmed = window.confirm(
      "체크된 사원의 임금데이터를 임금메이커로 [ 내보내기 ] 하시겠습니까?"
    );
    if (isConfirmed) {
      const selectedRow = checkedRows[0];

      year.value = selectedRow.ct_start_year;
      month.value = selectedRow.ct_start_month;
      timePay.value = nc(selectedRow.ct_time_pay) || 0;
      basicWorkTime.value = selectedRow.ct_basic_work_time;
      overWorkTime.value = selectedRow.ct_over_work_time;
      nightWorkTime.value = selectedRow.ct_night_work_time;
      overWorkDaysPercent.value = selectedRow.ct_over_work_days_percent;
      nightWorkDaysPercent.value = selectedRow.ct_night_work_days_percent;
      bojonPay.value = nc(selectedRow.ct_bojon_pay) || 0;
      dangPay.value = nc(selectedRow.ct_dang_pay) || 0;
      lunchPay.value = nc(selectedRow.ct_lunch_pay) || 0;
      carPay.value = nc(selectedRow.ct_car_pay) || 0;
      childPay.value = nc(selectedRow.ct_child_pay) || 0;
      if (selectedRow.ct_wage_type === '기본') {
        wageVersion.value = 1;
      } else if (selectedRow.ct_wage_type === '주주야야비비') {
        wageVersion.value = 2;
      }
  await filterList();

    }

  } else {
    alert("체크된 사원이 없습니다.");
  }
};

const updateWorkDays = async () => {
  await getMonthHolidays();
  let allWorkDays = getWorkDays(year.value, month.value);
  if (year.value >= 2025) {
    timePay.value = 10030;
  } else {
    timePay.value = 9860;
  }
  // 순서대로 합치기
  wageLists.value = allWorkDays;
  console.log(wageLists.value, 'wageLists.value')
};

const updatePays = async () => {
  let allWorkDays = getWorkDays(year.value, month.value);
  wageLists.value = allWorkDays;
};

watch(year, updateWorkDays);
watch(month, updateWorkDays);
watch(timePay, updatePays);
watch(basicWorkTime, updatePays);
watch(overWorkTime, updatePays);
watch(nightWorkTime, updatePays);
watch(overWorkDaysPercent, updatePays);
watch(nightWorkDaysPercent, updatePays);
watch(bojonPay, updatePays);
watch(dangPay, updatePays);
watch(lunchPay, updatePays);
watch(carPay, updatePays);
watch(childPay, updatePays);
watch(wageVersion, updatePays);


const getWorkDays = (year: number, month: number) => {
  let results = [];
  let totals = {
    totalDays: 0,
    onlyBlackDays: 0,
    saturdayCount: 0,
    sundayCount: 0,
    holidayCount: 0,
    basicTimeMonth: 0,
    overTimeMonth: 0,
    nightTimeMonth: 0,
    basicPay: 0,
    overPay: 0,
    nightPay: 0,
    totalPay: 0,
  };

  if (wageVersion.value === 1) {

    // 12개월 동안 반복
    for (let i = 0; i < 12; i++) {
      let currentYear = year;
      let currentMonth = month + i;

      // 월이 12를 초과할 경우 연도를 증가시키고, 월을 1월로 리셋
      if (currentMonth > 12) {
        currentYear++;
        currentMonth = currentMonth - 12;
      }

      let totalDays = new Date(currentYear, currentMonth, 0).getDate();
      let firstDayOfWeek = new Date(currentYear, currentMonth - 1, 1).getDay();

      let saturdayCount = 0;
      let sundayCount = 0;
      let holidayCount = 0;

      let weekFullyStarted = true; // 기본적으로 모든 주 포함

      // 1월: 첫 주가 월요일로 시작하지 않으면 토/일 제외
      if (i === 0 && firstDayOfWeek !== 1) {
        weekFullyStarted = false;
      }

      for (let day = 1; day <= totalDays; day++) {
        let date = new Date(currentYear, currentMonth - 1, day);
        let dayOfWeek = date.getDay();
        let formattedDate = `${String(currentMonth).padStart(2, "0")}-${String(
          day
        ).padStart(2, "0")}`;

        // 첫 주 제외 로직
        if (!weekFullyStarted && (dayOfWeek === 6 || dayOfWeek === 0)) {
          continue;
        }

        if (dayOfWeek === 6) saturdayCount++;
        if (dayOfWeek === 0) sundayCount++;
        if (holidays.value.includes(formattedDate)) holidayCount++;

        if (dayOfWeek === 5) {
          weekFullyStarted = true;
        }
      }

      let onlyBlackDays = totalDays - (saturdayCount + sundayCount + holidayCount) || 0; // 근로일 계산

      let basicWorkDays = onlyBlackDays + sundayCount + holidayCount || 0;

      let basicTimeMonth =
        parseFloat((basicWorkDays * basicWorkTime.value).toFixed(2)) || 0;
      let overTimeMonth =
        parseFloat(
          (
            ((onlyBlackDays * overWorkDaysPercent.value) / 100) *
            overWorkTime.value
          ).toFixed(2)
        ) || 0;
      let nightTimeMonth =
        parseFloat(
          (
            ((onlyBlackDays * nightWorkDaysPercent.value) / 100) *
            nightWorkTime.value
          ).toFixed(2)
        ) || 0;

      let basicPay =
        ac(Math.ceil(basicWorkDays * basicWorkTime.value * timePay.value)) || 0;
      let overPay = ac(Math.ceil(overTimeMonth * timePay.value * 1.5)) || 0;
      let nightPay = ac(Math.ceil(nightTimeMonth * timePay.value * 0.5)) || 0;
      let bojonPay_format = bojonPay.value || 0;
      let dangPay_format = dangPay.value || 0;
      let lunchPay_format = lunchPay.value || 0;
      let carPay_format = carPay.value || 0;
      let childPay_format = childPay.value || 0;
      let totalPay =
        ac(
          nc(basicPay) +
          nc(overPay) +
          nc(nightPay) +
          nc(bojonPay_format) +
          nc(lunchPay_format) +
          nc(carPay_format) +
          nc(childPay_format) +
          nc(dangPay_format)
        ) || 0;

      if (i === 11) {
        endYear.value = currentYear;
        endMonth.value = currentMonth;
      }
      // 해당 월의 결과 저장
      results.push({
        year: currentYear,
        month: currentMonth,
        totalDays,
        onlyBlackDays: onlyBlackDays,
        saturdayCount,
        sundayCount,
        weekendCount: saturdayCount + sundayCount,
        holidayCount,
        basicTimeMonth,
        overTimeMonth,
        nightTimeMonth,
        basicPay,
        overPay,
        nightPay,
        totalPay,
      });

      // 합산
      totals.totalDays += totalDays || 0;
      totals.onlyBlackDays += onlyBlackDays || 0;
      totals.saturdayCount += saturdayCount || 0;
      totals.sundayCount += sundayCount || 0;
      totals.holidayCount += holidayCount || 0;
      totals.basicTimeMonth += basicTimeMonth || 0;
      totals.overTimeMonth += overTimeMonth || 0;
      totals.nightTimeMonth += nightTimeMonth || 0;
    }

    let sumBasicPay = Math.ceil(totals.basicTimeMonth * timePay.value);
    let sumOverPay = Math.ceil(totals.overTimeMonth * timePay.value * 1.5);
    let sumNightPay = Math.ceil(totals.nightTimeMonth * timePay.value * 0.5);

    // 합계 추가
    sumResults.value = {
      month: "합계",
      totalDays: totals.totalDays || 0,
      onlyBlackDays: totals.onlyBlackDays || 0,
      saturdayCount: totals.saturdayCount || 0,
      sundayCount: totals.sundayCount || 0,
      weekendCount: totals.saturdayCount + totals.sundayCount || 0,
      holidayCount: totals.holidayCount || 0,
      basicTimeMonth: totals.basicTimeMonth.toFixed(2) || 0,
      overTimeMonth: totals.overTimeMonth.toFixed(2) || 0,
      nightTimeMonth: totals.nightTimeMonth.toFixed(2) || 0,
      basicPay: ac(sumBasicPay) || 0,
      overPay: ac(sumOverPay) || 0,
      nightPay: ac(sumNightPay) || 0,
      totalPay: ac(nc(sumBasicPay) + nc(sumOverPay) + nc(sumNightPay)) || 0,

    };

    // 평균 추가 (반올림)

    let avgBasicTimeMonth = parseFloat((totals.basicTimeMonth / 12).toFixed(2));
    let avgOverTimeMonth = parseFloat((totals.overTimeMonth / 12).toFixed(2));
    let avgNightTimeMonth = parseFloat((totals.nightTimeMonth / 12).toFixed(2));

    if (avgBasicTimeMonth >= 209.1 && avgBasicTimeMonth <= 209.9) {
      // 209.1~209.9 사이일 경우 소수점 절삭 (내림)
      avgBasicTimeMonth = Math.floor(avgBasicTimeMonth);
    } else if (avgBasicTimeMonth >= 208 && avgBasicTimeMonth <= 208.9) {
      avgBasicTimeMonth = Math.ceil(avgBasicTimeMonth);
    } else {
      // 그 외의 경우는 반올림
      avgBasicTimeMonth = Math.round(avgBasicTimeMonth);
    }
    let avgBasicPay = Math.ceil(avgBasicTimeMonth * timePay.value);
    let avgOverPay = Math.ceil(avgOverTimeMonth * timePay.value * 1.5);
    let avgNightPay = Math.ceil(avgNightTimeMonth * timePay.value * 0.5);

    let bojonPay_format = bojonPay.value || 0;
    let lunchPay_format = lunchPay.value || 0;
    let carPay_format = carPay.value || 0;
    let childPay_format = childPay.value || 0;
    let dangPay_format = dangPay.value || 0;
    avgResults.value = {
      month: "평균",
      totalDays: (totals.totalDays / 12).toFixed(2) || 0,
      onlyBlackDays: (totals.onlyBlackDays / 12).toFixed(2) || 0,
      saturdayCount: (totals.saturdayCount / 12).toFixed(2) || 0,
      sundayCount: (totals.sundayCount / 12).toFixed(2) || 0,
      weekendCount: ((totals.saturdayCount + totals.sundayCount) / 12).toFixed(2) || 0,
      holidayCount: (totals.holidayCount / 12).toFixed(2) || 0,

      basicTimeMonth: avgBasicTimeMonth || 0,
      overTimeMonth: avgOverTimeMonth || 0,
      nightTimeMonth: avgNightTimeMonth || 0,

      basicPay: ac(avgBasicPay) || 0,
      overPay: ac(avgOverPay) || 0,
      nightPay: ac(avgNightPay) || 0,

      totalPay:
        ac(
          avgBasicPay +
          avgOverPay +
          avgNightPay +
          nc(bojonPay_format) +
          nc(lunchPay_format) +
          nc(carPay_format) +
          nc(childPay_format) +
          nc(dangPay_format)
        ) || 0,
    };
  } else if (wageVersion.value === 2) {
    // 합계 추가
    let totalDays = 365;
    let juganDays = parseFloat((totalDays / 3).toFixed(2)) || 0;
    let yaganDays = parseFloat((totalDays / 3).toFixed(2)) || 0;
    let bibunDays = parseFloat((totalDays / 3).toFixed(2)) || 0;
    let juhyuDays = 52;


    let basicWorkDays = juganDays + yaganDays + juhyuDays;
    let basicTimeMonth = basicWorkDays * basicWorkTime.value || 0;

    let overTimeMonth =
      parseFloat(
        (
          juganDays *
          overWorkTime.value
        ).toFixed(2)
      ) || 0;
    let nightTimeMonth =
      parseFloat(
        (
          yaganDays *
          nightWorkTime.value
        ).toFixed(2)
      ) || 0;

    let sumBasicPay = Math.ceil(basicTimeMonth * timePay.value);
    let sumOverPay = Math.ceil(overTimeMonth * timePay.value * 1.5);
    let sumNightPay = Math.ceil(nightTimeMonth * timePay.value * 0.5);

    sumResults.value = {
      month: "합계",
      totalDays: totalDays,
      juganDays: juganDays,
      yaganDays: yaganDays,
      bibunDays: bibunDays,
      juhyuDays: juhyuDays,
      basicTimeMonth: ac(basicTimeMonth) || 0,
      overTimeMonth: ac(overTimeMonth) || 0,
      nightTimeMonth: ac(nightTimeMonth) || 0,
      basicPay: ac(sumBasicPay) || 0,
      overPay: ac(sumOverPay) || 0,
      nightPay: ac(sumNightPay) || 0,
      totalPay: ac(nc(sumBasicPay) + nc(sumOverPay) + nc(sumNightPay)) || 0,
    };

    let totalDaysAvg = (sumResults.value.totalDays / 12).toFixed(2) || 0;
    let juganDaysAvg = parseFloat((sumResults.value.juganDays / 12).toFixed(2)) || 0;
    let yaganDaysAvg = parseFloat((sumResults.value.yaganDays / 12).toFixed(2)) || 0;
    let bibunDaysAvg = parseFloat((sumResults.value.bibunDays / 12).toFixed(2)) || 0;
    let juhyuDaysAvg = parseFloat((sumResults.value.juhyuDays / 12).toFixed(2)) || 0;

    let basicTimeMonthAvg = Math.ceil((juganDaysAvg + yaganDaysAvg + juhyuDaysAvg) * basicWorkTime.value) || 0;
    let overTimeMonthAvg = parseFloat((juganDaysAvg * overWorkTime.value).toFixed(2)) || 0;
    let nightTimeMonthAvg = parseFloat((yaganDaysAvg * nightWorkTime.value).toFixed(2)) || 0;

    let basicPayAvg = basicTimeMonthAvg * timePay.value || 0;
    let overPayAvg = Math.ceil(overTimeMonthAvg * timePay.value * 1.5) || 0;
    let nightPayAvg = Math.ceil(nightTimeMonthAvg * timePay.value * 0.5) || 0;

    avgResults.value = {
      month: "평균",
      totalDays: totalDaysAvg,
      juganDays: juganDaysAvg,
      yaganDays: yaganDaysAvg,
      bibunDays: bibunDaysAvg,
      juhyuDays: juhyuDaysAvg,

      basicTimeMonth: ac(basicTimeMonthAvg),
      overTimeMonth: ac(overTimeMonthAvg),
      nightTimeMonth: ac(nightTimeMonthAvg),

      basicPay: ac(basicPayAvg) || 0,
      overPay: ac(overPayAvg) || 0,
      nightPay: ac(nightPayAvg) || 0,
      totalPay: ac(basicPayAvg + overPayAvg + nightPayAvg) || 0,

    };
  }

  // 수당은 모두 반올림 고정,
  return results;
};

const getYears = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get("/api/getYears");
    if (response.data) {
      yearOptions.value = response.data;
      const currentYear = new Date().getFullYear();
      year.value = currentYear;
    } else {
      console.error("연도 정보를 불러오는 데 실패했습니다.");
    }
  } catch (error) {
    console.error("에러 발생:", error);
  } finally {
    isLoading.value = false;
    await updateWorkDays();
  }
};
const getMonthHolidays = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get(
      `/api/getMonthHolidays/${year.value}/${month.value}`
    );
    if (response.data) {
      holidays.value = response.data;
    } else {
      console.error("공휴일정보를 불러오는 데 실패했습니다.");
    }
  } catch (error) {
    console.error("에러 발생:", error);
  } finally {
    isLoading.value = false;
  }
};
const getEmpContractInfo = async () => {
  isLoading.value = true;
  try {
    const response = await axios.get(
      `/api/getEmpContractInfo/${sisulCode.value}`
    );
    if (response.data) {
      empList.value = response.data.map((emp: any) => ({
        ...emp,
        ct_lunch_pay: ac(emp.ct_lunch_pay),
        ct_bojon_pay: ac(emp.ct_bojon_pay),
        ct_car_pay: ac(emp.ct_car_pay),
        ct_child_pay: ac(emp.ct_child_pay),
        ct_dang_pay: ac(emp.ct_dang_pay),
        ct_time_pay: ac(emp.ct_time_pay)
      }));
    } else {
      console.error("사원정보 불러오기에 실패하였습니다.");
    }
  } catch (error) {
    console.error("에러 발생:", error);
  } finally {
    isLoading.value = false;
  }
};


const saveEmpWageContract = async () => {
  isLoading.value = true;
  try {
    const allEmployees = empList.value.map((emp: any) => ({
      ...emp,
      ct_lunch_pay: nc(emp.ct_lunch_pay),
      ct_bojon_pay: nc(emp.ct_bojon_pay),
      ct_car_pay: nc(emp.ct_car_pay),
      ct_child_pay: nc(emp.ct_child_pay),
      ct_time_pay: nc(emp.ct_time_pay),
      ct_dang_pay: nc(emp.ct_dang_pay)
    }));
    
    const response = await axios.post("/api/saveEmpWageContract", {
      form: allEmployees,
    });
    const result = response.data;
    if (!result.success) {
      alert("실패하였습니다. 관리자에게 문의해주세요.");
    }
  } catch (error) {
    alert("처리할 수 없습니다.");
    console.error(error);
  } finally {
    isLoading.value = false;
    await filterList();
  }
};
const deleteEmpContract = async (ct_idx: any) => {
  const isConfirmed = window.confirm("삭제하시겠습니까?");
  if (isConfirmed) {
    isLoading.value = true;
    try {
      const response = await axios.post(`/api/deleteEmpContract/${ct_idx}`);
      if (response) {
        await getYears();
        await filterList();
      } else {
        alert("삭제에 실패했습니다.");
      }
    } catch (error) {
      alert("처리할 수 없습니다.");
      console.error(error);
    } finally {
      isLoading.value = false;
    }
  }
};

const openBatchEditModal = () => {
  const checkedRows = empList.value.filter((row: Employee) => row.checked);
  
  if (checkedRows.length === 0) {
    alert("일괄 변경할 사원을 체크해주세요.");
    return;
  }
  
  // 초기화
  batchFields.value = [];
  batchEditType.value = 'absolute';
  batchEditValue.value = null;
  batchEditDialog.value = true;
};

const applyBatchEdit = async () => {
  if (batchFields.value.length === 0) {
    alert("변경할 항목을 선택해주세요.");
    return;
  }
  
  if (batchEditValue.value === null) {
    alert("변경할 값을 입력해주세요.");
    return;
  }
  
  const checkedRows = empList.value.filter((row: Employee) => row.checked);
  
  const isConfirmed = window.confirm(`체크한 ${checkedRows.length}명의 사원에 대해 일괄 변경을 적용하시겠습니까?`);
  if (!isConfirmed) return;
  
  isLoading.value = true;
  try {
    empList.value = empList.value.map((row: Employee) => {
      if (row.checked) {
        const updatedRow = { ...row } as Employee;
        
        batchFields.value.forEach(field => {
          if (field in updatedRow) {
            const fieldValue = nc(updatedRow[field as keyof Employee] as any) || 0;
            let newFieldValue = 0;
            
            switch (batchEditType.value) {
              case 'absolute':
                newFieldValue = Number(batchEditValue.value);
                break;
              case 'amount':
                newFieldValue = fieldValue + Number(batchEditValue.value);
                break;
            }
            
            (updatedRow as any)[field] = ac(newFieldValue);
          }
        });
        
        totalPay(updatedRow);
        
        return updatedRow;
      }
      return row;
    });
    
    batchEditDialog.value = false;
    
    const checkedEmployees = empList.value.filter((emp: Employee) => emp.checked).map((emp: any) => ({
      ...emp,
      ct_lunch_pay: nc(emp.ct_lunch_pay),
      ct_bojon_pay: nc(emp.ct_bojon_pay),
      ct_car_pay: nc(emp.ct_car_pay),
      ct_child_pay: nc(emp.ct_child_pay),
      ct_time_pay: nc(emp.ct_time_pay),
      ct_dang_pay: nc(emp.ct_dang_pay)
    }));
    
    const response = await axios.post("/api/saveEmpWageContract", {
      form: checkedEmployees,
    });
    const result = response.data;
    if (!result.success) {
      alert("실패하였습니다. 관리자에게 문의해주세요.");
    }
  } catch (error) {
    alert("처리할 수 없습니다.");
    console.error(error);
  } finally {
    isLoading.value = false;
    await filterList();
  }
};

onMounted(async () => {
  const currentDate = new Date();
  refYearMonth.value =
    currentDate.getFullYear() + "년 " + (currentDate.getMonth() + 1) + "월";
  await getYears();
  await filterList();
});


return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_container, {
      fluid: "",
      class: "pa-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_overlay, {
          "model-value": isLoading.value,
          class: "align-center justify-center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              color: "primary",
              indeterminate: "",
              size: "64"
            })
          ]),
          _: 1
        }, 8, ["model-value"]),
        _createVNode(_component_v_card, { class: "rounded-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-file")
                    ]),
                    _: 1
                  }),
                  _hoisted_2,
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_btn, {
                      style: {"border-radius":"5px","margin-right":"5px"},
                      color: wageVersion.value === 1 ? '#1325c6' : 'white',
                      class: _normalizeClass(wageVersion.value === 1 ? 'text-white' : 'text-black border'),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (setWageDateVersion(1)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 기본 ")
                      ]),
                      _: 1
                    }, 8, ["color", "class"]),
                    _createVNode(_component_v_btn, {
                      style: {"border-radius":"5px"},
                      color: wageVersion.value === 2 ? '#1325c6' : 'white',
                      class: _normalizeClass(wageVersion.value === 2 ? 'text-white' : 'text-black border'),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (setWageDateVersion(2)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 주주야야비비 ")
                      ]),
                      _: 1
                    }, 8, ["color", "class"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "empContractSheet" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: timePay.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((timePay).value = $event)),
                          label: "시급",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"120px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: basicWorkTime.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((basicWorkTime).value = $event)),
                          label: "기본근로(h)",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"110px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: overWorkTime.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((overWorkTime).value = $event)),
                          label: "연장근로(h)",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"110px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      (wageVersion.value === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_v_text_field, {
                              class: "input-right",
                              modelValue: overWorkDaysPercent.value,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((overWorkDaysPercent).value = $event)),
                              label: "연장근로(d)",
                              type: "number",
                              "hide-details": "auto",
                              density: "compact",
                              variant: "outlined",
                              style: {"width":"110px"}
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: _unref(nightWorkTime),
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(nightWorkTime) ? (nightWorkTime).value = $event : null)),
                          label: "야간근로(h)",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"110px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      (wageVersion.value === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_v_text_field, {
                              class: "input-right",
                              modelValue: nightWorkDaysPercent.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((nightWorkDaysPercent).value = $event)),
                              label: "야간근로(d)",
                              type: "number",
                              "hide-details": "auto",
                              density: "compact",
                              variant: "outlined",
                              style: {"width":"110px"}
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: lunchPay.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((lunchPay).value = $event)),
                          label: "중식대",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"120px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: carPay.value,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((carPay).value = $event)),
                          label: "차량비",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"120px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: childPay.value,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((childPay).value = $event)),
                          label: "양육비",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"120px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: bojonPay.value,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((bojonPay).value = $event)),
                          label: "보존수당",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"120px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_v_text_field, {
                          class: "input-right",
                          modelValue: dangPay.value,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dangPay).value = $event)),
                          label: "당직수당",
                          type: "number",
                          "hide-details": "auto",
                          density: "compact",
                          variant: "outlined",
                          style: {"width":"120px"}
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_18, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_19,
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_20, "일수"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_21, "일수"))
                            : _createCommentVNode("", true),
                          _hoisted_22,
                          _hoisted_23
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_24,
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_25, "근로"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_26, "토"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_27, "일"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_28, "소계"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_29, "공휴일"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_30, "주간"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_31, "야간"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_32, "비번"))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_33, "주휴일"))
                            : _createCommentVNode("", true),
                          _createElementVNode("th", null, "기본(" + _toDisplayString(basicWorkTime.value || 0) + "h)", 1),
                          _createElementVNode("th", null, "연장(" + _toDisplayString(overWorkTime.value || 0) + "h)", 1),
                          _createElementVNode("th", null, "야간(" + _toDisplayString(_unref(nightWorkTime) || 0) + "h)", 1),
                          _hoisted_34,
                          _hoisted_35,
                          _hoisted_36,
                          _hoisted_37,
                          _hoisted_38,
                          _hoisted_39,
                          _hoisted_40,
                          _hoisted_41,
                          _hoisted_42,
                          (openMonthDataStatus.value && wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("th", {
                                key: 9,
                                onClick: openMonthDataToggle,
                                class: "cursorPointer"
                              }, " 닫기↑ "))
                            : (!openMonthDataStatus.value && wageVersion.value === 1)
                              ? (_openBlock(), _createElementBlock("th", {
                                  key: 10,
                                  onClick: openMonthDataToggle,
                                  class: "cursorPointer"
                                }, " 열기↓ "))
                              : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (openMonthDataStatus.value && wageVersion.value === 1)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(wageLists.value, (row, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(row.year) + "년 " + _toDisplayString(row.month) + "월", 1),
                                _createElementVNode("td", null, _toDisplayString(row.totalDays), 1),
                                _createElementVNode("td", null, _toDisplayString(row.onlyBlackDays), 1),
                                _createElementVNode("td", null, _toDisplayString(row.saturdayCount), 1),
                                _createElementVNode("td", null, _toDisplayString(row.sundayCount), 1),
                                _createElementVNode("td", null, _toDisplayString(row.saturdayCount + row.sundayCount), 1),
                                _createElementVNode("td", null, _toDisplayString(row.holidayCount), 1),
                                _createElementVNode("td", null, _toDisplayString(row.basicTimeMonth), 1),
                                _createElementVNode("td", null, _toDisplayString(row.overTimeMonth), 1),
                                _createElementVNode("td", null, _toDisplayString(row.nightTimeMonth), 1),
                                _createElementVNode("td", _hoisted_43, _toDisplayString(row.basicPay), 1),
                                _createElementVNode("td", _hoisted_44, _toDisplayString(row.overPay), 1),
                                _createElementVNode("td", _hoisted_45, _toDisplayString(row.nightPay), 1),
                                _createElementVNode("td", _hoisted_46, _toDisplayString(ac(bojonPay.value) || 0), 1),
                                _createElementVNode("td", _hoisted_47, _toDisplayString(ac(dangPay.value) || 0), 1),
                                _createElementVNode("td", _hoisted_48, _toDisplayString(ac(lunchPay.value) || 0), 1),
                                _createElementVNode("td", _hoisted_49, _toDisplayString(ac(carPay.value) || 0), 1),
                                _createElementVNode("td", _hoisted_50, _toDisplayString(ac(childPay.value) || 0), 1),
                                _createElementVNode("td", _hoisted_51, _toDisplayString(row.totalPay), 1)
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("tr", _hoisted_52, [
                          _createElementVNode("td", null, _toDisplayString(sumResults.value.month), 1),
                          _createElementVNode("td", null, _toDisplayString(sumResults.value.totalDays), 1),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_53, _toDisplayString(sumResults.value.onlyBlackDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_54, _toDisplayString(sumResults.value.saturdayCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_55, _toDisplayString(sumResults.value.sundayCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_56, _toDisplayString(sumResults.value.weekendCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_57, _toDisplayString(sumResults.value.holidayCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_58, _toDisplayString(sumResults.value.juganDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_59, _toDisplayString(sumResults.value.yaganDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(sumResults.value.bibunDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_61, _toDisplayString(sumResults.value.juhyuDays), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, _toDisplayString(sumResults.value.basicTimeMonth), 1),
                          _createElementVNode("td", null, _toDisplayString(sumResults.value.overTimeMonth), 1),
                          _createElementVNode("td", null, _toDisplayString(sumResults.value.nightTimeMonth), 1),
                          _createElementVNode("td", _hoisted_62, _toDisplayString(sumResults.value.basicPay), 1),
                          _createElementVNode("td", _hoisted_63, _toDisplayString(sumResults.value.overPay), 1),
                          _createElementVNode("td", _hoisted_64, _toDisplayString(sumResults.value.nightPay), 1),
                          _createElementVNode("td", _hoisted_65, _toDisplayString(ac(bojonPay.value * 12) || 0), 1),
                          _createElementVNode("td", _hoisted_66, _toDisplayString(ac(dangPay.value * 12) || 0), 1),
                          _createElementVNode("td", _hoisted_67, _toDisplayString(ac(lunchPay.value * 12) || 0), 1),
                          _createElementVNode("td", _hoisted_68, _toDisplayString(ac(carPay.value * 12) || 0), 1),
                          _createElementVNode("td", _hoisted_69, _toDisplayString(ac(childPay.value * 12) || 0), 1),
                          _createElementVNode("td", _hoisted_70, _toDisplayString(sumResults.value.totalPay), 1)
                        ]),
                        _createElementVNode("tr", _hoisted_71, [
                          _createElementVNode("td", null, _toDisplayString(avgResults.value.month), 1),
                          _createElementVNode("td", null, _toDisplayString(avgResults.value.totalDays), 1),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_72, _toDisplayString(avgResults.value.onlyBlackDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_73, _toDisplayString(avgResults.value.saturdayCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_74, _toDisplayString(avgResults.value.sundayCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_75, _toDisplayString(avgResults.value.weekendCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_76, _toDisplayString(avgResults.value.holidayCount), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_77, _toDisplayString(avgResults.value.juganDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_78, _toDisplayString(avgResults.value.yaganDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_79, _toDisplayString(avgResults.value.bibunDays), 1))
                            : _createCommentVNode("", true),
                          (wageVersion.value === 2)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_80, _toDisplayString(avgResults.value.juhyuDays), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, _toDisplayString(avgResults.value.basicTimeMonth), 1),
                          _createElementVNode("td", null, _toDisplayString(avgResults.value.overTimeMonth), 1),
                          _createElementVNode("td", null, _toDisplayString(avgResults.value.nightTimeMonth), 1),
                          _createElementVNode("td", _hoisted_81, _toDisplayString(avgResults.value.basicPay), 1),
                          _createElementVNode("td", _hoisted_82, _toDisplayString(avgResults.value.overPay), 1),
                          _createElementVNode("td", _hoisted_83, _toDisplayString(avgResults.value.nightPay), 1),
                          _createElementVNode("td", _hoisted_84, _toDisplayString(ac(bojonPay.value) || 0), 1),
                          _createElementVNode("td", _hoisted_85, _toDisplayString(ac(dangPay.value) || 0), 1),
                          _createElementVNode("td", _hoisted_86, _toDisplayString(ac(lunchPay.value) || 0), 1),
                          _createElementVNode("td", _hoisted_87, _toDisplayString(ac(carPay.value) || 0), 1),
                          _createElementVNode("td", _hoisted_88, _toDisplayString(ac(childPay.value) || 0), 1),
                          _createElementVNode("td", _hoisted_89, _toDisplayString(avgResults.value.totalPay), 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, { class: "rounded-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_90, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-file")
                    ]),
                    _: 1
                  }),
                  _hoisted_91,
                  _hoisted_92,
                  _hoisted_93,
                  _createElementVNode("b", _hoisted_94, _toDisplayString(refYearMonth.value), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, { class: "empContractSheet" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_95, [
                      _createVNode(_component_v_btn, {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (dialog.value = true)),
                        color: "grey-darken-1",
                        variant: "flat",
                        "prepend-icon": "mdi-filter-variant",
                        class: "mr-2",
                        size: "small",
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 조건검색 ")
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        onClick: saveEmpWageContract,
                        color: "primary",
                        variant: "elevated",
                        "prepend-icon": "mdi-content-save",
                        class: "mr-2",
                        size: "small",
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 저장하기 ")
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        onClick: wageInput,
                        color: "success",
                        variant: "flat",
                        "prepend-icon": "mdi-download",
                        class: "mr-2",
                        size: "small",
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 임금가져오기 ")
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        onClick: wageOutput,
                        color: "info",
                        variant: "flat",
                        "prepend-icon": "mdi-upload",
                        class: "mr-2",
                        size: "small",
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 임금내보내기 ")
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        onClick: openBatchEditModal,
                        color: "deep-purple",
                        variant: "flat",
                        "prepend-icon": "mdi-content-copy",
                        size: "small",
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 일괄 변경 ")
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _createElementVNode("table", _hoisted_96, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_97, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectAll).value = $event)),
                              onChange: toggleAll,
                              disabled: isLoading.value
                            }, null, 40, _hoisted_98), [
                              [_vModelCheckbox, selectAll.value]
                            ])
                          ]),
                          _hoisted_99,
                          _hoisted_100,
                          _hoisted_101,
                          _hoisted_102,
                          _hoisted_103,
                          _hoisted_104
                        ]),
                        _hoisted_105
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (row, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: _normalizeClass(["empContractListTr", { 'selectedRowBgColorChanger': row.checked }])
                          }, [
                            _createElementVNode("td", _hoisted_106, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": ($event: any) => ((row.checked) = $event),
                                disabled: isLoading.value
                              }, null, 8, _hoisted_107), [
                                [_vModelCheckbox, row.checked]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_108, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", _hoisted_109, [
                              _createTextVNode(_toDisplayString(row.emp_name) + " ", 1),
                              (row.emp_status === '1' || row.emp_status === 1)
                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 0,
                                    size: "x-small",
                                    color: "success",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 활성 ")
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_v_chip, {
                                    key: 1,
                                    size: "x-small",
                                    color: "error",
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 비활성 ")
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _createElementVNode("td", _hoisted_110, _toDisplayString(row.emp_job), 1),
                            _createElementVNode("td", _hoisted_111, _toDisplayString(row.emp_in_year || ""), 1),
                            _createElementVNode("td", _hoisted_112, _toDisplayString(row.emp_in_month || ""), 1),
                            _createElementVNode("td", _hoisted_113, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_basic_work_time_month) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_basic_work_time_month')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_basic_work_time_month')),
                                ref_for: true,
                                ref: el => setInputRef(index, 0, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 0)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 0)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 0)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 0)), ["prevent"]), ["right"])
                                ],
                                disabled: isLoading.value
                              }, null, 40, _hoisted_114), [
                                [_vModelText, row.ct_basic_work_time_month]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_115, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_over_work_time_month) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_over_work_time_month')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_over_work_time_month')),
                                ref_for: true,
                                ref: el => setInputRef(index, 1, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 1)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 1)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 1)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 1)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_116), [
                                [_vModelText, row.ct_over_work_time_month]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_117, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_night_work_time_month) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_night_work_time_month')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_night_work_time_month')),
                                ref_for: true,
                                ref: el => setInputRef(index, 2, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 2)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 2)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 2)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 2)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_118), [
                                [_vModelText, row.ct_night_work_time_month]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_119, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_time_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_time_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_time_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 3, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 3)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 3)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 3)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 3)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_120), [
                                [_vModelText, row.ct_time_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_121, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_basic_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_basic_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_basic_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 4, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 4)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 4)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 4)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 4)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_122), [
                                [_vModelText, row.ct_basic_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_123, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_over_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_over_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_over_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 5, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 5)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 5)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 5)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 5)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_124), [
                                [_vModelText, row.ct_over_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_125, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_night_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_night_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_night_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 6, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 6)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 6)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 6)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 6)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_126), [
                                [_vModelText, row.ct_night_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_127, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_bojon_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_bojon_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_bojon_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 7, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 7)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 7)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 7)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 7)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_128), [
                                [_vModelText, row.ct_bojon_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_129, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_dang_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_dang_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_dang_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 7, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 7)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 7)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 7)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 7)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_130), [
                                [_vModelText, row.ct_dang_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_131, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_lunch_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_lunch_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_lunch_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 8, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 8)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 8)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 8)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 8)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_132), [
                                [_vModelText, row.ct_lunch_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_133, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_car_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_car_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_car_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 9, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 9)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 9)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 9)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 9)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_134), [
                                [_vModelText, row.ct_car_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_135, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((row.ct_child_pay) = $event),
                                type: "text",
                                onFocus: ($event: any) => (clearFormat(row, 'ct_child_pay')),
                                onBlur: ($event: any) => (applyFormat(row, 'ct_child_pay')),
                                ref_for: true,
                                ref: el => setInputRef(index, 10, el),
                                onKeydown: [
                                  _withKeys(_withModifiers(($event: any) => (focusNextRow(index, 10)), ["prevent"]), ["down"]),
                                  _withKeys(_withModifiers(($event: any) => (focusPrevRow(index, 10)), ["prevent"]), ["up"]),
                                  _withKeys(_withModifiers(($event: any) => (focusLeftCol(index, 10)), ["prevent"]), ["left"]),
                                  _withKeys(_withModifiers(($event: any) => (focusRightCol(index, 10)), ["prevent"]), ["right"])
                                ]
                              }, null, 40, _hoisted_136), [
                                [_vModelText, row.ct_child_pay]
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_137, _toDisplayString(totalPay(row) || 0), 1),
                            _createElementVNode("td", _hoisted_138, _toDisplayString(row.ct_wage_type), 1),
                            _createElementVNode("td", {
                              onClick: ($event: any) => (deleteEmpContract(row.ct_idx)),
                              style: {"cursor":"pointer"}
                            }, "삭제", 8, _hoisted_139)
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _hoisted_140
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((dialog).value = $event)),
      "max-width": "500"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "rounded-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h5 font-weight-bold primary pa-4 text-white d-flex align-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  class: "mr-2",
                  color: "white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-filter-variant")
                  ]),
                  _: 1
                }),
                _createTextVNode(" 임금계약표 조건검색 ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "pa-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_alert, {
                  density: "compact",
                  type: "info",
                  variant: "tonal",
                  class: "mb-4",
                  icon: "mdi-information"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 임금계약 유형과 사원 상태를 선택하여 필터링합니다. ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_141, [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-tag-multiple")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 임금계약 유형 ")
                        ]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: selectedType.value,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedType).value = $event)),
                          label: "기본",
                          value: "기본",
                          color: "primary",
                          "hide-details": "",
                          class: "mb-2",
                          onChange: filterList
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: selectedType.value,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedType).value = $event)),
                          label: "주주야야비비",
                          value: "주주야야비비",
                          color: "primary",
                          "hide-details": "",
                          class: "mb-2",
                          onChange: filterList
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: selectedType.value,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((selectedType).value = $event)),
                          label: "없음",
                          value: "",
                          color: "primary",
                          "hide-details": "",
                          onChange: filterList
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider, { class: "my-4" }),
                _createVNode(_component_v_row, { class: "mt-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_142, [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-account-check")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 사원 상태 ")
                        ]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: selectedStatus.value,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((selectedStatus).value = $event)),
                          label: "활성 사원",
                          value: "1",
                          color: "primary",
                          "hide-details": "",
                          class: "mb-2",
                          onChange: filterList
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: selectedStatus.value,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((selectedStatus).value = $event)),
                          label: "비활성(퇴사) 사원",
                          value: "0",
                          color: "primary",
                          "hide-details": "",
                          onChange: filterList
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4 bg-grey-lighten-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  "prepend-icon": "mdi-check",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 확인 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: batchEditDialog.value,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((batchEditDialog).value = $event)),
      "max-width": "600"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "rounded-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _hoisted_143
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "pa-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_alert, {
                  density: "compact",
                  type: "info",
                  variant: "tonal",
                  class: "mb-4",
                  icon: "mdi-information"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 체크한 사원들의 임금계약 정보를 일괄 변경합니다. ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-format-list-checks")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 변경할 항목 ")
                        ]),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((batchFields).value = $event)),
                                  label: "시급",
                                  value: "ct_time_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((batchFields).value = $event)),
                                  label: "기본 근로시간",
                                  value: "ct_basic_work_time_month",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((batchFields).value = $event)),
                                  label: "연장 근로시간",
                                  value: "ct_over_work_time_month",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((batchFields).value = $event)),
                                  label: "야간 근로시간",
                                  value: "ct_night_work_time_month",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((batchFields).value = $event)),
                                  label: "기본급",
                                  value: "ct_basic_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((batchFields).value = $event)),
                                  label: "연장수당",
                                  value: "ct_over_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((batchFields).value = $event)),
                                  label: "야간수당",
                                  value: "ct_night_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((batchFields).value = $event)),
                                  label: "보존수당",
                                  value: "ct_bojon_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((batchFields).value = $event)),
                                  label: "당직수당",
                                  value: "ct_dang_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((batchFields).value = $event)),
                                  label: "중식대",
                                  value: "ct_lunch_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((batchFields).value = $event)),
                                  label: "차량비",
                                  value: "ct_car_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: batchFields.value,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((batchFields).value = $event)),
                                  label: "양육비",
                                  value: "ct_child_pay",
                                  "hide-details": "",
                                  color: "primary",
                                  class: "my-0 py-1",
                                  density: "compact"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider, { class: "my-4" }),
                _createVNode(_component_v_row, { class: "mt-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            color: "primary",
                            class: "mr-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-cog-outline")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" 변경 방식 ")
                        ]),
                        _createVNode(_component_v_radio_group, {
                          modelValue: batchEditType.value,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((batchEditType).value = $event)),
                          inline: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_radio, {
                              color: "primary",
                              value: "absolute",
                              label: "직접 입력 값으로 변경"
                            }),
                            _createVNode(_component_v_radio, {
                              color: "primary",
                              value: "amount",
                              label: "금액 증감"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          modelValue: batchEditValue.value,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((batchEditValue).value = $event)),
                          label: batchEditType.value === 'absolute' ? '변경할 값' : '증감 금액',
                          type: "number",
                          hint: batchEditType.value === 'amount' ? '예: 10000 → 10,000원 증가, -10000 → 10,000원 감소' : '',
                          "persistent-hint": "",
                          variant: "outlined",
                          color: "primary",
                          density: "compact",
                          prefix: batchEditType.value === 'amount' && batchEditValue.value && batchEditValue.value > 0 ? '+' : '',
                          "hide-details": "auto"
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_v_icon, { color: "primary" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(batchEditType.value === 'absolute' ? 'mdi-currency-krw' : 'mdi-math-compass'), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label", "hint", "prefix"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4 bg-grey-lighten-4" }, {
              default: _withCtx(() => [
                (batchFields.value.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      color: "primary",
                      size: "small",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(batchFields.value.length) + "개 항목 선택됨 ", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey-darken-1",
                  variant: "text",
                  "prepend-icon": "mdi-close",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (batchEditDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 취소 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "elevated",
                  "prepend-icon": "mdi-check",
                  class: "ml-2",
                  disabled: batchFields.value.length === 0 || batchEditValue.value === null,
                  onClick: applyBatchEdit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 적용 ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})